/**
 * Strip all non-digit characters from a phone number.
 * For US numbers starting with "1", removes the leading "1".
 * @param {string} value - Raw phone input
 * @returns {string} Digits only, e.g. "9162322332"
 */
export function stripPhone(value) {
  if (!value) return "";
  let digits = value.replace(/\D/g, "");
  // Remove leading country code "1" if 11 digits
  if (digits.length === 11 && digits.startsWith("1")) {
    digits = digits.slice(1);
  }
  return digits;
}

/**
 * Format a phone number for display as 916.232.2332
 * Only formats 10-digit US numbers; returns original for others.
 * @param {string} value - Raw or stripped phone number
 * @returns {string} Formatted phone, e.g. "916.232.2332"
 */
export function formatPhone(value) {
  const digits = stripPhone(value);
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
  }
  return value || "";
}

/**
 * Format phone as user types, showing dots progressively.
 * @param {string} value - Current input value
 * @returns {string} Partially formatted phone
 */
export function formatPhoneInput(value) {
  const digits = stripPhone(value);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 10)}`;
}
